export function successToas() {
    return {
        title: "Sukses",
        variant: 'success',
        solid: true
    }
}

export function warningToas() {
    return {
        title: "Warning",
        variant: 'warning',
        solid: true
    }
}

export function errorToas() {
    return {
        title: "Error",
        variant: 'danger',
        solid: true
    }
}

export const Notif = {
    success: {
        title: "Sukses",
        variant: 'success',
    },
    error: {
        title: "Error",
        variant: 'danger',
    },
    warning: {
        title: "Warning",
        variant: 'warning',
    }
}